import { Link } from "react-router-dom";
import { useModal } from "@/hooks/useModal";

export default function Hero() {
  const { openQuote } = useModal();
  return (
    <section className="relative w-full overflow-hidden min-h-[600px] md:min-h-[720px] flex items-center">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20moody%20enterprise%20server%20room%20interior%20with%20rows%20of%20rack-mounted%20hardware%20emitting%20cool%20blue%20LED%20lights%2C%20abstract%20digital%20data%20streams%20and%20network%20nodes%20floating%20in%20the%20air%2C%20cybersecurity%20operations%20center%20aesthetic%20with%20deep%20navy%20and%20electric%20blue%20color%20palette%2C%20cinematic%20dramatic%20lighting%20with%20soft%20bokeh%20glow%20effects%2C%20high-end%20corporate%20technology%20photography%20with%20clean%20composition%20and%20no%20people%20visible%2C%20suitable%20as%20a%20professional%20website%20hero%20background&width=1920&height=1080&seq=hero-v10&orientation=landscape"
          alt="Presuni enterprise IT infrastructure"
          className="w-full h-full object-cover object-center"
          loading="eager"
          fetchpriority="high"
          width={1920}
          height={1080}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/40" />
      </div>

      {/* Floating particles / grid overlay */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-20 right-20 w-64 h-64 border border-brand-400/30 rounded-full" />
        <div className="absolute bottom-40 right-40 w-48 h-48 border border-brand-400/20 rounded-full" />
        <div className="absolute top-1/3 right-1/4 w-2 h-2 bg-brand-400 rounded-full animate-pulse" />
        <div className="absolute top-1/2 right-1/3 w-1.5 h-1.5 bg-brand-300 rounded-full animate-pulse" style={{ animationDelay: "1s" }} />
        <div className="absolute bottom-1/3 right-1/5 w-2 h-2 bg-brand-500 rounded-full animate-pulse" style={{ animationDelay: "2s" }} />
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-8 pt-[104px] md:pt-[120px]">
        <div className="max-w-4xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-md border border-white/20 mb-6">
            <div className="w-2 h-2 rounded-full bg-brand-400 animate-pulse" />
            <span className="text-xs font-medium text-white/90 tracking-wide">
              Trusted by 120+ Enterprise Clients Since 2006
            </span>
          </div>

          <h1 className="text-[2rem] sm:text-5xl md:text-6xl lg:text-7xl font-extrabold text-white leading-[1.15] tracking-tight mb-6">
            Secure your business.
            <br />
            Engineer tomorrow.
            <br />
            <span className="bg-gradient-to-r from-[#2563eb] to-[#60a5fa] bg-clip-text text-transparent">#Trusted innovation</span>
          </h1>

          <p className="text-base md:text-lg text-gray-300 leading-relaxed mb-10 max-w-2xl">
            PRESUNI delivers enterprise-grade cybersecurity, custom software development, and expert IT consulting. Based in the UK, trusted by SMEs &amp; corporations across the Midlands and beyond.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={openQuote}
              className="px-8 py-4 rounded-full bg-brand-500 text-white text-sm font-semibold hover:bg-brand-600 transition-all duration-200 shadow-lg shadow-brand-500/25 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
            >
              <i className="ri-rocket-line" />
              Talk to an Expert
            </button>
            <Link
              to="/services"
              className="px-8 py-4 rounded-full bg-white/10 backdrop-blur-sm text-white text-sm font-semibold hover:bg-white/20 transition-all duration-200 border border-white/20 whitespace-nowrap cursor-pointer text-center flex items-center justify-center gap-2"
            >
              <i className="ri-stack-line" />
              Our Services
            </Link>
          </div>

          {/* Trust bar */}
          <div className="mt-12 md:mt-16 flex flex-wrap items-center gap-6 md:gap-10">
            <div className="flex items-center gap-2 text-white/60">
              <i className="ri-shield-check-line text-brand-400 text-lg" />
              <span className="text-xs font-medium">ISO 27001 Certified</span>
            </div>
            <div className="flex items-center gap-2 text-white/60">
              <i className="ri-lock-line text-brand-400 text-lg" />
              <span className="text-xs font-medium">NIST Framework Aligned</span>
            </div>
            <div className="flex items-center gap-2 text-white/60">
              <i className="ri-cloud-line text-brand-400 text-lg" />
              <span className="text-xs font-medium">Multi-Cloud Experts</span>
            </div>
            <div className="flex items-center gap-2 text-white/60">
              <i className="ri-time-line text-brand-400 text-lg" />
              <span className="text-xs font-medium">18+ Years Experience</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}